import { OnboardEmployeeDetails } from './OnboardEmployeeDetails';
import { OnboardEmployeePersonalDetails } from './OnboardEmployeePersonalDetails';
import { OnboardEmployeeFinanceDetails } from './OnboardEmployeeFinanceDetails';

export class OnboardEmployee {
  employeeDetails: OnboardEmployeeDetails = new OnboardEmployeeDetails();
  personalDetails: OnboardEmployeePersonalDetails = new OnboardEmployeePersonalDetails();
  financeDetails: OnboardEmployeeFinanceDetails = new OnboardEmployeeFinanceDetails();
}
